import moment from 'moment';

const DATE_FORMAT = 'YYYY-MM-DD HH:mm:ss';

export const getScheduleDateRange = (
	timeView,
	isMobile,
	startOfWeek = 'Monday',
	daysData = null
) => {
	// Calculate week boundaries based on organization's start_of_week
	const dayMap: { [key: string]: number } = {
		Sunday: 0,
		Monday: 1,
		Tuesday: 2,
		Wednesday: 3,
		Thursday: 4,
		Friday: 5,
		Saturday: 6,
	};

	// Convert startOfWeek from /api/days/id format to day label
	let startDayLabel = startOfWeek;
	if (daysData && Array.isArray(daysData) && startOfWeek.startsWith('/api/days/')) {
		const dayObj = daysData.find((day: any) => {
			const dayId = day['@id'] || `/api/days/${day.id}`;
			return dayId === startOfWeek;
		});
		if (dayObj && dayObj.label) {
			startDayLabel = dayObj.label;
		}
	}

	const startDayOfWeek = dayMap[startDayLabel] ?? 1; // Default to Monday
	const currentDate = moment();
	const currentDay = currentDate.day();

	// Calculate how many days to subtract to get to the start of the business week
	const daysToSubtract = (currentDay - startDayOfWeek + 7) % 7;
	// Week starts at 00:00 on the first day
	const firstday = currentDate.clone().subtract(daysToSubtract, 'days').startOf('day');

	// Week ends at 23:59:59 on the 7th day (6 days after start)
	const lastday = firstday.clone().add(6, 'days').endOf('day');

	// Return absolute dates without timezone conversion
	return [firstday.format(DATE_FORMAT), lastday.format(DATE_FORMAT)];
};
